import { Button, Modal } from "antd";
import styled from "styled-components";

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px !important;
    overflow: hidden;
  }

  .ant-modal-header {
    border-bottom: 1px solid #e2e8f0;
    padding: 16px 24px;
    border-radius: 12px 12px 0 0;
  }

  .ant-modal-title {
    font-family: "Open Sans", sans-serif;
    font-weight: 700;
    font-size: 18px;
    color: #020618;
  }

  .ant-modal-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 24px 16px;
  }

  .ant-modal-close {
    color: #62748e;
  }
`;

export const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    width: 22px;
    height: 22px;
    color: rgb(172, 32, 32);
    flex-shrink: 0;
  }
`;

export const IconCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: rgb(253, 236, 236);
  margin-bottom: 20px;

  svg {
    width: 28px;
    height: 28px;
    color: rgb(172, 32, 32);
  }
`;

export const Question = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  color: #020618;
  text-align: center;
  margin-bottom: 4px;
`;

export const OrderNumber = styled.span`
  font-weight: 700;
  color: #020618;
`;

export const Subtitle = styled.p`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: #62748e;
  text-align: center;
  margin-bottom: 32px;
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: calc(100% + 48px);
  margin: 8px -24px 0;
  padding: 16px 24px 0;
  border-top: 1px solid #e2e8f0;
`;

const FooterButton = styled(Button)`
  border-radius: 8px;
  height: 40px;
  padding: 0 20px;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
  box-shadow: 0px 1px 2px 0px #19191c0a;
  transition: all 300ms ease-in-out;
`;

export const NoButton = styled(FooterButton)`
  color: #314158;
  background-color: #fff;
  border-color: #e2e8f0;

  &:hover,
  &:focus {
    color: #314158;
    background-color: #f8fafc;
    border-color: #cbd5e1;
  }
`;

export const YesButton = styled(FooterButton)`
  color: #fff;
  background-color: rgb(172, 32, 32);
  border-color: rgb(172, 32, 32);

  &:hover,
  &:focus {
    color: #fff;
    background-color: rgb(140, 26, 26);
    border-color: rgb(140, 26, 26);
  }

  &:disabled,
  &:disabled:hover {
    background-color: rgb(172, 32, 32);
    border-color: rgb(172, 32, 32);
    color: #fff;
    opacity: 0.7;
  }
`;
